"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactComponents = require("@cimpress/react-components");
var _emotion = require("emotion");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var errorDetailBlockClass = (0, _emotion.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 16px;\n"])));
var isValidJson = function isValidJson(content) {
  try {
    JSON.parse(content);
    return true;
  } catch (error) {
    return false;
  }
};
var PriceError = function PriceError(_ref) {
  var error = _ref.error;
  var title = error.title,
    detail = error.detail,
    causes = error.causes,
    additionalData = error.additionalData,
    sourceError = error.sourceError;
  var hasCalculationErrors = Array.isArray(sourceError === null || sourceError === void 0 ? void 0 : sourceError.errors) && sourceError.errors.length > 0;
  var hasCauses = Array.isArray(causes) && causes.some(function (cause) {
    return Object.keys(cause).length > 0;
  });
  var shouldDisplayErrorDetail = detail && !isValidJson(detail);
  return /*#__PURE__*/_react["default"].createElement(_reactComponents.Alert, {
    title: title,
    message: /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, shouldDisplayErrorDetail && /*#__PURE__*/_react["default"].createElement("div", {
      className: errorDetailBlockClass
    }, detail), additionalData && /*#__PURE__*/_react["default"].createElement("div", {
      className: errorDetailBlockClass
    }, /*#__PURE__*/_react["default"].createElement("pre", null, JSON.stringify(additionalData, null, 4))), hasCalculationErrors && /*#__PURE__*/_react["default"].createElement("div", {
      className: errorDetailBlockClass
    }, /*#__PURE__*/_react["default"].createElement("pre", null, JSON.stringify(sourceError.errors, null, 4))), !hasCalculationErrors && hasCauses && /*#__PURE__*/_react["default"].createElement("div", {
      className: errorDetailBlockClass
    }, /*#__PURE__*/_react["default"].createElement("pre", null, JSON.stringify(causes, null, 4)))),
    dismissible: false
  });
};
PriceError.propTypes = {
  error: _propTypes["default"].object.isRequired
};
var _default = PriceError;
exports["default"] = _default;